module.exports = __webpack_public_path__ + "img/88b0e118517908b9eee32658ffe94efe.png";